module.exports = __webpack_public_path__ + "files/d4e0d7638282a0006e1b20a0123fdeaa.png";